<template>
  <v-app id="inspire" :class="{ horizontalstyle: true }">
    <!-- ---------------------------------- -->
    <!--- Vertical Header part -->
    <!-- ---------------------------------- -->
    <!-- ---------------------------------- -->
    <!--- Horizontal Header part -->
    <!-- ---------------------------------- -->
    <HorizontalHeader></HorizontalHeader>

    <v-main style="    padding: 52px 0px 60px 0px !important;     max-width: 100%">
      <v-container fluid class="page-wrapper">
        <router-view />
        
      </v-container>
    </v-main>
    <!-- ---------------------------------- -->
    <!--- Vertical Sidebar  part -->
    <!-- ---------------------------------- -->
    <!-- ---------------------------------- -->
    <!--- Horizontal Sidebar part -->
    <!-- ---------------------------------- -->
    <HorizontalSidebar></HorizontalSidebar>
    <!-- ---------------------------------- -->
    <!--- Customizer part -->
    <!-- ---------------------------------- -->
    <Customizer v-model="expandOnHover"></Customizer>
    <!-- ---------------------------------- -->
    <!--- Vertical Footer part -->
    <!-- ---------------------------------- -->
    <Footer v-if="false"></Footer>
    <!-- ---------------------------------- -->
    <!--- Horizontal Footer part -->
    <!-- ---------------------------------- -->
    <HorizontalFooter v-else></HorizontalFooter>
  </v-app>
</template>

<script>
import HorizontalHeader from "./horizontal-header/HorizontalHeader";
import HorizontalSidebar from "./horizontal-sidebar/HorizontalSidebar";
import Footer from "./footer/Footer";
import HorizontalFooter from "./horizontal-footer/HorizontalFooter";
import Customizer from "./customizer/Customizer";
import { mapState, mapMutations } from "vuex";
export default {
  name: "Layout",

  components: {
    HorizontalHeader,
    HorizontalSidebar,
    Footer,
    HorizontalFooter,
    Customizer,
  },

  props: {
    source: String,
  },
  data: () => ({
    expandOnHover: false,
  }),
  computed: {
    ...mapState(["Customizer_drawer", "setHorizontalLayout"]),
  },

  methods: {
    ...mapMutations({
      setCustomizerDrawer: "SET_CUSTOMIZER_DRAWER",
    }),
  },
};
</script>

<style>
</style>